"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImmunizationEvaluation = void 0;
/**
 * Describes a comparison of an immunization event against published recommendations to determine if the administration is \"valid\" in relation to those  recommendations.
 */
var ImmunizationEvaluation = /** @class */ (function () {
    function ImmunizationEvaluation() {
    }
    return ImmunizationEvaluation;
}());
exports.ImmunizationEvaluation = ImmunizationEvaluation;
